module.exports = __webpack_public_path__ + "static/img/payewm3.6040ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payewm3.png
// module id = F6sK
// module chunks = 2